import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	inject,
	Input,
	Output,
	signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { IAssetTimeSeries } from '@app/pages/cmms/components/assets/asset-time-series/misc/interfaces';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AuRoundAvatarModule } from '@shared/ui-components';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'chart-modal-edit-form',
	templateUrl: './chart-modal-edit-form.component.html',
	styleUrls: ['./chart-modal-edit-form.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		MatIconModule,
		MatButtonModule,
		MatRippleModule,
		MatDatepickerModule,
		MatDialogModule,
		AuRoundAvatarModule,
		NgxTolgeeModule,
	],
})
export class ChartModalEditFormComponent {
	private readonly element = inject(ElementRef);
	private readonly fb = inject(FormBuilder);

	@Input() set data(data: IAssetTimeSeries) {
		this.dataPointValue = data;
		this.myForm.patchValue({ value: data.value, date: data.datetime });
	}

	@Input() unit: string;

	@Output() closeEmitted = new EventEmitter<void>();
	@Output() saveEmitted = new EventEmitter<{ value: number; date: Date; pk: string }>();
	@Output() deleteEmitted = new EventEmitter<{ pk: string }>();

	myForm = this.fb.group({
		value: [0, [Validators.required, Validators.min(1)]],
		date: ['', [Validators.required]],
	});

	@HostListener('document:click', ['$event'])
	public documentClick(event: MouseEvent): void {
		const rect = this.element.nativeElement.getBoundingClientRect();

		if (
			// this needs because datepicker is bigger than bounderies of modal
			!this.datePickerOpened() &&
			rect &&
			(event.clientX < rect.left ||
				event.clientX > rect.right ||
				event.clientY < rect.top ||
				event.clientY > rect.bottom)
		) {
			this.closeEmitted.emit();
		}
	}

	datePickerOpened = signal(false);
	dataPointValue: IAssetTimeSeries;

	isEditEnabled = signal(false); // TODO: Implement a feature flag for organization

	submit() {
		if (this.myForm.valid) {
			this.saveEmitted.emit({
				value: +this.myForm.value.value,
				date: new Date(this.myForm.value.date),
				pk: this.dataPointValue.pk,
			});
			this.closeEmitted.emit();
		}
	}

	closeClicked() {
		this.closeEmitted.emit();
	}

	deleteClicked() {
		this.deleteEmitted.emit({
			pk: this.dataPointValue.pk,
		});

		this.closeEmitted.emit();
	}
}
